/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LanguageDto } from '../models';
/**
 * SuccessionReportRestApi - axios parameter creator
 * @export
 */
export const SuccessionReportRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Excel report from succession_report_view
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSuccessionReportExcel: async (lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/successions/report/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuccessionReportRestApi - functional programming interface
 * @export
 */
export const SuccessionReportRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuccessionReportRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate Excel report from succession_report_view
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSuccessionReportExcel(lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSuccessionReportExcel(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionReportRestApi.generateSuccessionReportExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuccessionReportRestApi - factory interface
 * @export
 */
export const SuccessionReportRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuccessionReportRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate Excel report from succession_report_view
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSuccessionReportExcel(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateSuccessionReportExcel(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuccessionReportRestApi - interface
 * @export
 * @interface SuccessionReportRestApi
 */
export interface SuccessionReportRestApiInterface {
    /**
     * 
     * @summary Generate Excel report from succession_report_view
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionReportRestApiInterface
     */
    generateSuccessionReportExcel(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<File>;

}

/**
 * SuccessionReportRestApi - object-oriented interface
 * @export
 * @class SuccessionReportRestApi
 * @extends {BaseAPI}
 */
export class SuccessionReportRestApi extends BaseAPI implements SuccessionReportRestApiInterface {
    /**
     * 
     * @summary Generate Excel report from succession_report_view
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionReportRestApi
     */
    public generateSuccessionReportExcel(lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionReportRestApiFp(this.configuration).generateSuccessionReportExcel(lang, options).then((request) => request(this.axios, this.basePath));
    }
}

